var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBank(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 14H15V13C15 12.4688 14.5312 12 14 12V7H12V12H9V7H7V12H4V7H2V12C1.4375 12 1 12.4688 1 13V14H0.5C0.21875 14 0 14.25 0 14.5V15.5C0 15.7812 0.21875 16 0.5 16H15.5C15.75 16 16 15.7812 16 15.5V14.5C16 14.25 15.75 14 15.5 14ZM15.6562 2.90625L8.34375 0.09375C8.25 0.03125 8.09375 0 8 0C7.875 0 7.71875 0.03125 7.625 0.09375L0.3125 2.90625C0.125 2.96875 0 3.15625 0 3.375V4.5C0 4.78125 0.21875 5 0.5 5H1V5.5C1 5.78125 1.21875 6 1.5 6H14.5C14.75 6 15 5.78125 15 5.5V5H15.5C15.75 5 16 4.78125 16 4.5V3.375C16 3.15625 15.8438 2.96875 15.6562 2.90625ZM8 4.5C7.4375 4.5 7 4.0625 7 3.5C7 2.96875 7.4375 2.5 8 2.5C8.53125 2.5 9 2.96875 9 3.5C9 4.0625 8.53125 4.5 8 4.5Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.56ef06d806dd72dc0002c2ad4b78adf3.svg";
export { ForwardRef as ReactComponent };